import { render, staticRenderFns } from "./MultiPlacePicker.vue?vue&type=template&id=284f3e19&scoped=true"
import script from "./MultiPlacePicker.vue?vue&type=script&lang=ts"
export * from "./MultiPlacePicker.vue?vue&type=script&lang=ts"
import style0 from "./MultiPlacePicker.vue?vue&type=style&index=0&id=284f3e19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f3e19",
  null
  
)

export default component.exports